import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";

const DataTableList = () => {
  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filters, setFilters] = useState({
    jobType: "",
    companyName: "",
    city: "",
    salaryMin: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          "https://dev-example.sanbercloud.com/api/job-vacancy",
          {
            headers: { Authorization: `Bearer ${Cookies.get("token")}` },
          }
        );
        setData(res.data.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleDelete = async (id) => {
    try {
      await axios.delete(
        `https://dev-example.sanbercloud.com/api/job-vacancy/${id}`,
        {
          headers: { Authorization: `Bearer ${Cookies.get("token")}` },
        }
      );
      setData(data.filter((item) => item.id !== id));
    } catch (error) {
      console.error("Error deleting data:", error);
    }
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleFilterChange = (event) => {
    setFilters({ ...filters, [event.target.name]: event.target.value });
  };

  const filteredData = data
    .filter((item) =>
      item.title.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .filter(
      (item) =>
        (filters.jobType ? item.job_type === filters.jobType : true) &&
        (filters.companyName
          ? item.company_name
              .toLowerCase()
              .includes(filters.companyName.toLowerCase())
          : true) &&
        (filters.city ? item.company_city === filters.city : true) &&
        (filters.salaryMin
          ? item.salary_min >= parseInt(filters.salaryMin)
          : true)
    );

  return (
    <div className="container mx-auto mt-24 mb-20 px-4">
      <div className="mb-6 flex justify-between items-center">
        <input
          type="text"
          placeholder="Search by job title"
          value={searchTerm}
          onChange={handleSearch}
          className="border rounded px-4 py-2 w-1/2"
        />
        <div className="flex space-x-4">
          <input
            type="text"
            name="jobType"
            placeholder="Filter by job type"
            value={filters.jobType}
            onChange={handleFilterChange}
            className="border rounded px-4 py-2"
          />
          <input
            type="text"
            name="companyName"
            placeholder="Filter by company name"
            value={filters.companyName}
            onChange={handleFilterChange}
            className="border rounded px-4 py-2"
          />
          <input
            type="text"
            name="city"
            placeholder="Filter by city"
            value={filters.city}
            onChange={handleFilterChange}
            className="border rounded px-4 py-2"
          />
          <input
            type="number"
            name="salaryMin"
            placeholder="Filter by minimum salary"
            value={filters.salaryMin}
            onChange={handleFilterChange}
            className="border rounded px-4 py-2"
          />
        </div>
      </div>
      <table className="min-w-full bg-white border border-gray-200">
        <thead>
          <tr className="border-b bg-gray-100">
            <th className="p-4 text-left">Title</th>
            <th className="p-4 text-left">Job Type</th>
            <th className="p-4 text-left">Company Name</th>
            <th className="p-4 text-left">City</th>
            <th className="p-4 text-left">Salary Min</th>
            <th className="p-4 text-left">Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredData.length === 0 ? (
            <tr>
              <td colSpan="6" className="p-4 text-center">
                No data available
              </td>
            </tr>
          ) : (
            filteredData.map((item) => (
              <tr key={item.id} className="border-b">
                <td className="p-4">{item.title}</td>
                <td className="p-4">{item.job_type}</td>
                <td className="p-4">{item.company_name}</td>
                <td className="p-4">{item.company_city}</td>
                <td className="p-4">{item.salary_min}</td>
                <td className="p-4">
                  <Link to={`/dashboard/list-job-vacancy/edit/${item.id}`}>
                    <button className="bg-blue-500 text-white px-4 py-2 rounded">
                      Edit
                    </button>
                  </Link>
                  <button
                    onClick={() => handleDelete(item.id)}
                    className="bg-red-500 text-white px-4 py-2 rounded ml-2"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DataTableList;
